<template>
  <v-layout justify-space-between>
    <v-flex xs7>{{ step.title }}</v-flex>
    <v-flex
      xs3
      text-xs-right>{{ step.date | timezone }}</v-flex>
    <v-flex
      xs2
      text-xs-right
    >
      {{ step.created_by }}
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'OrderSingleTimelineItem',

  props: {
    step: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },

  computed: {
    getIndex () {
      return this.index % 2 === 0
    }
  }
}
</script>
